import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import css from './event-list.module.css';
import { route } from '../../../../../../services/utils';
import { LIVESTOCK_ANIMALS_AND_EVENTS_INDEX } from '../../../../../../router/routes';
import AnimalsAndEventsTabKeys from '../../../enums/animals-and-events-tab-keys';
import { useHistory, useParams } from 'react-router-dom';
import { useQuery } from '../../../../../../hooks/use-query';
import './create-buttons.css';

enum Status {
  planned = 'planned',
  missed = 'missed',
  completed = 'completed',
}
interface Props {
  missedCount: number;
  plannedCount: number;
  completedCount: number;
  noticesCount: number;
}

export default function EventListFilter({
  missedCount,
  plannedCount,
  completedCount,
  noticesCount,
}: Props) {
  const { t } = useTranslation();
  const { replace } = useHistory();

  const query = useQuery();
  const { month, year, mode, date, statuses = '' } = query[0]!;
  const { farmId } = useParams<{
    farmId: string;
  }>();
  const [statusesData, setStatusesData] = useState(statuses.split(','));

  const changeStatus = (status?: string) => {
    const currentMonth = new Date().getMonth() + 1;
    const localStatuses = [...statusesData];
    if (!localStatuses.includes(status)) {
      localStatuses.unshift(status);
      setStatusesData(localStatuses);
    } else {
      const idx = localStatuses.indexOf(status);
      localStatuses.splice(idx, 1);
      setStatusesData(localStatuses);
    }

    replace(
      route(
        LIVESTOCK_ANIMALS_AND_EVENTS_INDEX.concat(
          '?year=:year&month=:month&date=:date&mode=:mode&statuses=:statuses'
        ),
        {
          farmId,
          tab: AnimalsAndEventsTabKeys.events,
          year: year || '',
          month: month || String(currentMonth).padStart(2, '0'),
          date: date || JSON.stringify(new Date()).slice(1, 11),
          mode: mode || 'month',
          statuses: localStatuses || '',
        }
      )
    );
  };

  return (
    <>
      <div className={css['event-bar']}>
        <div className={css['checkbox-container']}>
          <div className={css['checkbox-item']}>
            <input
              type="checkbox"
              id="event_missed"
              checked={statusesData.includes(Status.missed)}
              onChange={() => changeStatus('missed')}
              className={css['checkbox']}
            />
            <label htmlFor="event_missed" className={css['label']}>
              {t('pages.livestock.animals_and_events.events.missed')}
            </label>
            <div className="relative inline-block ml-2.5">
              <span className="px-2 py-1 text-xs font-bold leading-none text-white bg-[#d40000] rounded-full">
                {missedCount}
              </span>
            </div>
          </div>
          <div className={css['checkbox-item']}>
            <input
              type="checkbox"
              id="event_planned"
              checked={statusesData.includes(Status.planned)}
              onChange={() => changeStatus('planned')}
              className={css['checkbox']}
            />
            <label htmlFor="event_planned" className={css['label']}>
              {t('pages.livestock.animals_and_events.events.the_planned_ones')}
            </label>
            <div className="relative inline-block ml-2.5">
              <span className="px-2 py-1 text-xs font-bold leading-none border-2 border-[#12589F] text-[#12589F] bg-[#ffffff] rounded-full">
                {plannedCount}
              </span>
            </div>
          </div>
          <div className={css['checkbox-item']}>
            <input
              type="checkbox"
              id="event_completed"
              checked={statusesData.includes(Status.completed)}
              onChange={() => changeStatus('completed')}
              className={css['checkbox']}
            />
            <label htmlFor="event_completed" className={css['label']}>
              {t(
                'pages.livestock.animals_and_events.events.the_completed_ones'
              )}
            </label>
            <div className="relative inline-block ml-2.5">
              <span className="px-2 py-1 text-xs font-bold leading-none border-2 border-[#12589F] text-[#ffffff] bg-[#12589F] rounded-full">
                {completedCount}
              </span>
            </div>
          </div>
          <div className={css['checkbox-item']}>
            <label className={css['label']}>
              {t('pages.livestock.animals_and_events.events.notices')}
            </label>
            <div className="relative inline-block ml-2.5">
              <span className="px-2 py-1 text-xs font-bold leading-none text-white bg-[#d40000] rounded-full">
                {noticesCount}
              </span>
            </div>
          </div>
        </div>
        <div className={css['status-container']}>
          <div className={css['status-item']}>
            <div className={css['status-box-red']}></div>
            <span>{t('pages.livestock.animals_and_events.events.missed')}</span>
          </div>
          <div className={css['status-item']}>
            <div className={css['status-box-blue']}></div>
            <span>
              {t('pages.livestock.animals_and_events.events.completed')}
            </span>
          </div>
          <div className={css['status-item']}>
            <div className={css['status-box-empty']}></div>
            <span>
              {t('pages.livestock.animals_and_events.events.planned')}
            </span>
          </div>
        </div>
      </div>
      <hr style={{ color: '#f0f0f0' }} />
    </>
  );
}
